import React from "react"
import Hero from "../components/Hero"
import Flota from "../components/Flota"
import Layout from "../components/Layout"
import Information from "../components/Information"
import Reviews from "../components/Reviews"
import Seo from "../components/Seo"

export default function Home() {
  return (
    <Layout>
      <Seo title="Loki Rent a Car" />
      <Hero />
      <Flota />
      <Information />
      <Reviews />
    </Layout>
  )
}
